var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.192 24C8.928 24 8.688 23.88 8.52 23.688C7.656 22.704 0 13.992 0 9.192C0 4.128 4.128 0 9.192 0C14.256 0 18.384 4.128 18.384 9.192C18.384 13.968 10.728 22.704 9.864 23.688C9.696 23.88 9.456 24 9.192 24ZM9.192 1.824C5.136 1.824 1.824 5.136 1.824 9.192C1.824 12.36 6.648 18.672 9.192 21.696C11.736 18.696 16.56 12.36 16.56 9.192C16.56 5.136 13.248 1.824 9.192 1.824Z",
    fill: "#A37C4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19199 13.9199C6.64798 13.9199 4.58398 11.8559 4.58398 9.31186C4.58398 6.76786 6.64798 4.70386 9.19199 4.70386C11.736 4.70386 13.8 6.76786 13.8 9.31186C13.8 11.8559 11.736 13.9199 9.19199 13.9199ZM9.19199 6.52786C7.65599 6.52786 6.40799 7.77586 6.40799 9.31186C6.40799 10.8479 7.65599 12.0959 9.19199 12.0959C10.728 12.0959 11.976 10.8479 11.976 9.31186C11.976 7.77586 10.728 6.52786 9.19199 6.52786Z",
    fill: "#A37C4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.729d473399eaae55492fb29a0d590d1c.svg";
export { ForwardRef as ReactComponent };